import React, { useState, useEffect, useContext } from 'react';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';




function SearchFilter(props) {

  const { setFilter, type } = props;

  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    setSearchValue('')
  }, [type]);

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value)

    setFilter(prevFilter => ({ ...prevFilter, search: e.target.value }));

  };



  return (
    <div >

      <Form.Control type="search" size="sm" placeholder="Search..."
        onChange={(e) => handleSearchChange(e)}
        value={searchValue}
      >
      </Form.Control>

    </div>
  )
}

export default SearchFilter;
